// Top 120 villes de Madagascar (chefs-lieux, communes urbaines, villes principales)
// Avec coordonnées GPS pour le filtre "rayon autour de"
// Trié par région pour faciliter la maintenance

export const MADA_CITIES = [
  // ── ANALAMANGA ──
  { name: "Antananarivo", region: "Analamanga", lat: -18.8792, lng: 47.5079 },
  { name: "Ambatolampy", region: "Vakinankaratra", lat: -19.3833, lng: 47.4167 },
  { name: "Ambohidratrimo", region: "Analamanga", lat: -18.8333, lng: 47.4500 },
  { name: "Andramasina", region: "Analamanga", lat: -19.2000, lng: 47.5833 },
  { name: "Anjozorobe", region: "Analamanga", lat: -18.4083, lng: 47.8467 },
  { name: "Ankazobe", region: "Analamanga", lat: -18.3167, lng: 47.1167 },
  { name: "Imerintsiatosika", region: "Itasy", lat: -18.9667, lng: 47.2500 },
  { name: "Manjakandriana", region: "Analamanga", lat: -18.9111, lng: 47.7950 },

  // ── VAKINANKARATRA ──
  { name: "Antsirabe", region: "Vakinankaratra", lat: -19.8742, lng: 47.0335 },
  { name: "Betafo", region: "Vakinankaratra", lat: -19.8333, lng: 46.8500 },
  { name: "Faratsiho", region: "Vakinankaratra", lat: -19.4000, lng: 46.9500 },
  { name: "Antanifotsy", region: "Vakinankaratra", lat: -19.6500, lng: 47.3167 },
  { name: "Mandoto", region: "Vakinankaratra", lat: -19.5667, lng: 46.3000 },

  // ── ITASY ──
  { name: "Miarinarivo", region: "Itasy", lat: -19.0000, lng: 46.7333 },
  { name: "Arivonimamo", region: "Itasy", lat: -19.0167, lng: 47.1833 },
  { name: "Soavinandriana", region: "Itasy", lat: -19.1667, lng: 46.7333 },

  // ── BONGOLAVA ──
  { name: "Tsiroanomandidy", region: "Bongolava", lat: -18.7667, lng: 46.0500 },
  { name: "Fenoarivobe", region: "Bongolava", lat: -18.4167, lng: 46.5667 },

  // ── ALAOTRA-MANGORO ──
  { name: "Ambatondrazaka", region: "Alaotra-Mangoro", lat: -17.8333, lng: 48.4167 },
  { name: "Amparafaravola", region: "Alaotra-Mangoro", lat: -17.5833, lng: 48.2167 },
  { name: "Andilamena", region: "Alaotra-Mangoro", lat: -17.0167, lng: 48.5667 },
  { name: "Anosibe an'Ala", region: "Alaotra-Mangoro", lat: -19.4333, lng: 48.2000 },
  { name: "Moramanga", region: "Alaotra-Mangoro", lat: -18.9333, lng: 48.2333 },

  // ── ATSINANANA (Toamasina côte est) ──
  { name: "Toamasina", region: "Atsinanana", lat: -18.1492, lng: 49.4023 },
  { name: "Brickaville", region: "Atsinanana", lat: -18.8167, lng: 49.0667 },
  { name: "Mahanoro", region: "Atsinanana", lat: -19.9000, lng: 48.8000 },
  { name: "Marolambo", region: "Atsinanana", lat: -20.0500, lng: 48.1333 },
  { name: "Vatomandry", region: "Atsinanana", lat: -19.3333, lng: 48.9833 },
  { name: "Antanambao Manampotsy", region: "Atsinanana", lat: -19.5333, lng: 48.6000 },

  // ── ANALANJIROFO (Fenoarivo Est) ──
  { name: "Fenoarivo Atsinanana", region: "Analanjirofo", lat: -17.3833, lng: 49.4000 },
  { name: "Mananara Nord", region: "Analanjirofo", lat: -16.1667, lng: 49.7667 },
  { name: "Maroantsetra", region: "Analanjirofo", lat: -15.4333, lng: 49.7333 },
  { name: "Sainte-Marie (Ambodifotatra)", region: "Analanjirofo", lat: -16.9667, lng: 49.8500 },
  { name: "Soanierana Ivongo", region: "Analanjirofo", lat: -16.9167, lng: 49.5833 },
  { name: "Vavatenina", region: "Analanjirofo", lat: -17.4667, lng: 49.2000 },

  // ── BOENY (Mahajanga) ──
  { name: "Mahajanga", region: "Boeny", lat: -15.7167, lng: 46.3167 },
  { name: "Ambato Boeny", region: "Boeny", lat: -16.4667, lng: 46.7167 },
  { name: "Marovoay", region: "Boeny", lat: -16.1000, lng: 46.6333 },
  { name: "Mitsinjo", region: "Boeny", lat: -16.0167, lng: 45.8667 },
  { name: "Soalala", region: "Boeny", lat: -16.1000, lng: 45.3667 },

  // ── BETSIBOKA ──
  { name: "Maevatanana", region: "Betsiboka", lat: -16.9500, lng: 46.8333 },
  { name: "Tsaratanana", region: "Betsiboka", lat: -16.7833, lng: 47.6500 },
  { name: "Kandreho", region: "Betsiboka", lat: -17.4833, lng: 46.0500 },

  // ── SOFIA ──
  { name: "Antsohihy", region: "Sofia", lat: -14.8833, lng: 47.9833 },
  { name: "Analalava", region: "Sofia", lat: -14.6333, lng: 47.7667 },
  { name: "Bealanana", region: "Sofia", lat: -14.5500, lng: 48.7333 },
  { name: "Befandriana Nord", region: "Sofia", lat: -15.2333, lng: 48.4833 },
  { name: "Mampikony", region: "Sofia", lat: -16.0833, lng: 47.6333 },
  { name: "Mandritsara", region: "Sofia", lat: -15.8333, lng: 48.8167 },
  { name: "Port-Bergé (Boriziny)", region: "Sofia", lat: -15.5667, lng: 47.6167 },

  // ── MELAKY ──
  { name: "Maintirano", region: "Melaky", lat: -18.0667, lng: 44.0167 },
  { name: "Antsalova", region: "Melaky", lat: -18.7000, lng: 44.6167 },
  { name: "Besalampy", region: "Melaky", lat: -16.7500, lng: 44.4833 },
  { name: "Morafenobe", region: "Melaky", lat: -17.8500, lng: 44.9167 },

  // ── MENABE (Morondava) ──
  { name: "Morondava", region: "Menabe", lat: -20.2833, lng: 44.2833 },
  { name: "Belo sur Tsiribihina", region: "Menabe", lat: -19.7000, lng: 44.5500 },
  { name: "Mahabo", region: "Menabe", lat: -20.4000, lng: 44.6667 },
  { name: "Manja", region: "Menabe", lat: -21.4167, lng: 44.3167 },
  { name: "Miandrivazo", region: "Menabe", lat: -19.5333, lng: 45.4667 },

  // ── AMORON'I MANIA ──
  { name: "Ambositra", region: "Amoron'i Mania", lat: -20.5306, lng: 47.2436 },
  { name: "Ambatofinandrahana", region: "Amoron'i Mania", lat: -20.5833, lng: 46.8000 },
  { name: "Fandriana", region: "Amoron'i Mania", lat: -20.2333, lng: 47.3833 },
  { name: "Manandriana", region: "Amoron'i Mania", lat: -20.6500, lng: 47.0500 },

  // ── HAUTE MATSIATRA (Fianarantsoa) ──
  { name: "Fianarantsoa", region: "Haute Matsiatra", lat: -21.4536, lng: 47.0854 },
  { name: "Ambalavao", region: "Haute Matsiatra", lat: -21.8333, lng: 46.9333 },
  { name: "Ambohimahasoa", region: "Haute Matsiatra", lat: -21.1167, lng: 47.2333 },
  { name: "Ikalamavony", region: "Haute Matsiatra", lat: -21.1667, lng: 46.5833 },
  { name: "Isandra (Mahasoabe)", region: "Haute Matsiatra", lat: -21.5333, lng: 47.0167 },
  { name: "Lalangina (Sahambavy)", region: "Haute Matsiatra", lat: -21.4500, lng: 47.1833 },
  { name: "Vohibato (Andrainjato)", region: "Haute Matsiatra", lat: -21.6500, lng: 46.9833 },

  // ── VATOVAVY ──
  { name: "Mananjary", region: "Vatovavy", lat: -21.2167, lng: 48.3333 },
  { name: "Ifanadiana", region: "Vatovavy", lat: -21.3000, lng: 47.6333 },
  { name: "Nosy Varika", region: "Vatovavy", lat: -20.5833, lng: 48.5333 },

  // ── FITOVINANY (Manakara) ──
  { name: "Manakara", region: "Fitovinany", lat: -22.1500, lng: 48.0167 },
  { name: "Ikongo", region: "Fitovinany", lat: -21.8833, lng: 47.4167 },
  { name: "Vohipeno", region: "Fitovinany", lat: -22.3500, lng: 47.8333 },

  // ── ATSIMO-ATSINANANA (Farafangana) ──
  { name: "Farafangana", region: "Atsimo-Atsinanana", lat: -22.8167, lng: 47.8333 },
  { name: "Vangaindrano", region: "Atsimo-Atsinanana", lat: -23.3500, lng: 47.6000 },
  { name: "Vondrozo", region: "Atsimo-Atsinanana", lat: -22.8167, lng: 47.2833 },
  { name: "Midongy-Atsimo", region: "Atsimo-Atsinanana", lat: -23.5667, lng: 47.0833 },
  { name: "Befotaka-Sud", region: "Atsimo-Atsinanana", lat: -23.8500, lng: 46.9667 },

  // ── IHOROMBE (Ihosy) ──
  { name: "Ihosy", region: "Ihorombe", lat: -22.4053, lng: 46.1131 },
  { name: "Iakora", region: "Ihorombe", lat: -23.1333, lng: 46.6833 },
  { name: "Ivohibe", region: "Ihorombe", lat: -22.4833, lng: 46.9000 },
  { name: "Ranohira", region: "Ihorombe", lat: -22.5667, lng: 45.4000 },

  // ── ATSIMO-ANDREFANA (Toliara) ──
  { name: "Toliara", region: "Atsimo-Andrefana", lat: -23.3517, lng: 43.6711 },
  { name: "Ampanihy Ouest", region: "Atsimo-Andrefana", lat: -24.6833, lng: 44.7333 },
  { name: "Ankazoabo Sud", region: "Atsimo-Andrefana", lat: -22.2833, lng: 44.5167 },
  { name: "Benenitra", region: "Atsimo-Andrefana", lat: -23.4500, lng: 45.0833 },
  { name: "Beroroha", region: "Atsimo-Andrefana", lat: -21.6833, lng: 45.1667 },
  { name: "Betioky Sud", region: "Atsimo-Andrefana", lat: -23.7167, lng: 44.3833 },
  { name: "Morombe", region: "Atsimo-Andrefana", lat: -21.7500, lng: 43.3667 },
  { name: "Sakaraha", region: "Atsimo-Andrefana", lat: -22.9167, lng: 44.5333 },

  // ── ANDROY ──
  { name: "Ambovombe-Androy", region: "Androy", lat: -25.1667, lng: 46.0833 },
  { name: "Bekily", region: "Androy", lat: -24.2333, lng: 45.3000 },
  { name: "Beloha", region: "Androy", lat: -25.1667, lng: 45.0500 },
  { name: "Tsihombe", region: "Androy", lat: -25.3167, lng: 45.5000 },

  // ── ANOSY (Fort-Dauphin) ──
  { name: "Taolagnaro (Fort-Dauphin)", region: "Anosy", lat: -25.0316, lng: 46.9994 },
  { name: "Amboasary Sud", region: "Anosy", lat: -25.0167, lng: 46.4500 },
  { name: "Betroka", region: "Anosy", lat: -23.2667, lng: 46.1000 },

  // ── DIANA (Diego-Suarez) ──
  { name: "Antsiranana (Diego-Suarez)", region: "Diana", lat: -12.2667, lng: 49.2917 },
  { name: "Ambanja", region: "Diana", lat: -13.6833, lng: 48.4500 },
  { name: "Ambilobe", region: "Diana", lat: -13.2000, lng: 49.0500 },
  { name: "Nosy Be (Hell-Ville)", region: "Diana", lat: -13.4040, lng: 48.2629 },

  // ── SAVA ──
  { name: "Sambava", region: "Sava", lat: -14.2667, lng: 50.1667 },
  { name: "Antalaha", region: "Sava", lat: -14.9000, lng: 50.2833 },
  { name: "Andapa", region: "Sava", lat: -14.6500, lng: 49.6500 },
  { name: "Vohémar (Iharana)", region: "Sava", lat: -13.3667, lng: 50.0000 },

  // ── Communes complémentaires souvent utilisées ──
  { name: "Tananarive Avaradrano", region: "Analamanga", lat: -18.8500, lng: 47.5500 },
  { name: "Antsahabe", region: "Analamanga", lat: -18.9333, lng: 47.5167 },
  { name: "Sabotsy-Namehana", region: "Analamanga", lat: -18.8000, lng: 47.5333 },
  { name: "Itaosy", region: "Analamanga", lat: -18.9167, lng: 47.4667 },
  { name: "Talatamaty", region: "Analamanga", lat: -18.8167, lng: 47.4667 },
  { name: "Alasora", region: "Analamanga", lat: -18.9333, lng: 47.5500 },
  { name: "Ankadikely Ilafy", region: "Analamanga", lat: -18.8333, lng: 47.5667 },
  { name: "Mahitsy", region: "Analamanga", lat: -18.7833, lng: 47.3500 },
];

// Recherche par texte (insensitive)
export const filterCities = (query) => {
  if (!query) return MADA_CITIES.slice(0, 30);
  const q = query.toLowerCase().trim();
  return MADA_CITIES.filter((c) =>
    c.name.toLowerCase().includes(q) || c.region.toLowerCase().includes(q)
  ).slice(0, 50);
};

// Trouve les coords pour un nom de ville (fuzzy)
export const findCityCoords = (cityName) => {
  if (!cityName) return null;
  const q = cityName.toLowerCase().trim();
  const exact = MADA_CITIES.find((c) => c.name.toLowerCase() === q);
  if (exact) return { lat: exact.lat, lng: exact.lng, name: exact.name };
  const startsWith = MADA_CITIES.find((c) => c.name.toLowerCase().startsWith(q));
  if (startsWith) return { lat: startsWith.lat, lng: startsWith.lng, name: startsWith.name };
  const contains = MADA_CITIES.find((c) => c.name.toLowerCase().includes(q));
  if (contains) return { lat: contains.lat, lng: contains.lng, name: contains.name };
  return null;
};

// Distance Haversine (en km)
export const haversineKm = (lat1, lng1, lat2, lng2) => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
};

export const RADIUS_OPTIONS = [
  { value: 5, label: "5 km" },
  { value: 10, label: "10 km" },
  { value: 25, label: "25 km" },
  { value: 50, label: "50 km" },
  { value: 100, label: "100 km" },
  { value: 250, label: "250 km" },
];
